export default __webpack_public_path__ + "static/media/1199.bc094308.png";